import script from "./BpmnView.vue?vue&type=script&setup=true&lang=js"
export * from "./BpmnView.vue?vue&type=script&setup=true&lang=js"

import "./BpmnView.vue?vue&type=style&index=0&id=97b64b12&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/zh-workflow-frontend_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97b64b12"]])

export default __exports__